export const LIGHTWEIGHT_TEMPLATE_ID = 'lightweight';
export const LOW_RES_DIMENSION = 360;
export const MID_RES_DIMENSION = 720;
